import api from './axios';

/**
 * Storage service for managing file uploads via Firebase
 * Handles the backend integration for the two-step upload process
 */
const storageService = {
    /**
     * Create a file record in the backend and get presigned upload URL
     * @param {Object} fileData - File metadata
     * @param {string} fileData.folder - Storage folder ('logos' or 'services')
     * @param {string} fileData.mimeType - MIME type of the file
     * @param {string} fileData.originalName - Original filename
     * @param {Object} [fileData.metadata] - Optional backend file metadata
     * @returns {Promise} API response with { id, uploadUrl, expiresAt, ... }
     */
    createFileRecord(fileData, orgContext = 'tenant') {
        return api.post('/storage', {
            folder: fileData.folder,
            mimeType: fileData.mimeType,
            originalName: fileData.originalName,
            metadata: fileData.metadata
        }, { orgContext });
    },

    /**
     * Delete a file record and associated Firebase file.
     * User-facing deletes are scoped to the selected tenant context.
     * @param {number} storageId - File storage ID
     * @returns {Promise} API response
     */
    deleteFile(storageId) {
        return api.delete(`/storage/${storageId}`, { orgContext: 'tenant' });
    }
};

export default storageService;
